import { Directive } from '@angular/core';

@Directive({
  selector: '[fEmptyStatesActions]',
  standalone: false
})
export class FireflyEmptyStatesDirective {}
